import { axiosWdw, domainEndpoint } from './axios';

const endpoint = '/timeline';

export default {
  getTimeline(timelineid: number) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + `${endpoint}/` + timelineid,
      })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getTimelineEntries(timelineid: number, params: any) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + `${endpoint}/` + timelineid + '/entry?' + `page=${params.page}`,
        data: params,
      })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
};
